import React from 'react';

type FieldConfigLabelSectionProps = {
    id?: string;
    label: string;
    placeholderSuffix?: string;
}

export const FieldConfigLabelSection: React.FC<FieldConfigLabelSectionProps> = ({
    id,
    label,
    placeholderSuffix = 'label'
}) => {
    const baseId = id || 'field-config-label-section';

    return (
        <div id={baseId} data-testid={baseId} className="tw-mb-6">
            <div id={`${baseId}-label`} className="tw-text-[#747593] tw-text-sm tw-mb-2">Label</div>
            <input
                id={`${baseId}-input`}
                data-testid={`${baseId}-input`}
                type="text"
                value={label}
                disabled
                className="tw-w-full tw-border tw-text-sm tw-text-[#172B4D] tw-font-medium tw-border-[#D1D1D6] tw-rounded tw-px-3 tw-py-2 tw-bg-[#F4F5F7] tw-cursor-not-allowed"
                placeholder={`${placeholderSuffix}`}
            />
        </div>
    );
};
